<template>
  <div class="check-icon-container d-flex align-items-center justify-content-center">
    <Icon
      :exp-active="true"
      :icon="isCheck ? 'tick' : 'close'"
      color="white"
      class="rounded-tick exp-design-bg"
      :class="{ gray: !isCheck }"
    />
  </div>
</template>

<script>
import Icon from 'UI/Icon';

export default {
  name: 'CrossCheckIcon',
  components: {
    Icon
  },
  props: {
    isCheck: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.check-icon-container {
  width: 25px;
  height: 25px;
  border-radius: 200%;
}
.check-icon-container > span {
  color: #fff;
  font-size: 15px;
}
.rounded-tick {
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  padding: 2px 3px;
  &.gray {
    background-color: $gray !important;
  }
}
</style>
